module.exports = __webpack_public_path__ + "img/tpc-26.a2c5acdd.jpg";